export interface ILead {
    "firstName": string,
    "lastName":  string,
    "jobTitle":  string,
    "company":  string,
    "mobile":  string,
    "telephone":  string,
    "email": string,
    "address1":  string,
    "address2":  string,
    "leadDate":  string,
    "callDetail": string,
    "callComments": string,
    "approverComments": string,
    "numerOfEmployees": string,
    "businessType":string,
    "revenue":string,
    "job":string
}

export enum LEAD_TYPE {
    CUSTOMER = "Customer",
    BUSINESS = "Business"
}

export interface LeadData {
    firstName: string;
    lastName: string;
    jobTitle: string;
    company: string;
    mobile: string;
    phone: string;
    email: string;
    noOfEmployees: string;
    businessType: string;
    revenue: string;
    address1: string;
    address2: string;
    record: string;
    comment: string;
    customer: {
        value: number;
        label: string;
    };
    addressOne: {
        addressLineOne: string;
        addressLineTwo: string;
        city: string;
        state: string;
        country: string;
    };
    addressTwo?:  {
        addressLineOne: string;
        addressLineTwo: string;
        city: string;
        state: string;
        country: string;
    };
    note: string;
    leadType: LEAD_TYPE;
    job?: {
    label: string;
    value: number;
    }
}


export enum LEAD_IDENTIFIERS {
    ALL_LEADS = "All",
    HOT_LEADS = 'HighIntent',
    WARM_LEADS = "LowIntent",
    INTERESTED_LEADS = "LowIntent",
}